import { Component, type PropsWithChildren, type ReactNode } from "react";

type RendererBoundaryProps = PropsWithChildren<{ fallback: ReactNode }>;
type RendererBoundaryState = { failed: boolean };

/** Keep an optional drawing backend failure inside the glyph, preserving its existing player. */
export class GraphemeGlyphRendererErrorBoundary extends Component<
  RendererBoundaryProps,
  RendererBoundaryState
> {
  state: RendererBoundaryState = { failed: false };

  static getDerivedStateFromError(): RendererBoundaryState {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
